import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { actionClearMessage } from '../../../redux-flow/actions/contratos'
import { Button, Empty, Icon, Modal, Upload, Tooltip, Input, Card as AntCard } from 'antd'
import { Line } from 'react-chartjs-2'
import './contratoWrapper.css'
import moment from 'moment'
import { API_URL, request, getInfoLocalStorage } from '../../../utils/api'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import attach from '../../../images/attach.png'
import NoContract from '../../../images/sem-contrato.png'
import modeloContrato from '../../../images/modelo-contrato.pdf'
import ModalAporte from '../ModalAporteSaque'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faDollarSign, faChartLine, faWallet, faCalendarAlt, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import ModalRenovacao from '../ModalRenovacao'
import { Link } from 'react-router-dom'
import { maskCpf } from '../../../utils/masks'
import { planos } from '../../../constants'

const { Dragger } = Upload;
let options = { 
        scales: {
            yAxes: [{
                ticks: {
                    callback: function(value, index, values){ return 'R$ ' + new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '') },
                    fontColor: "rgba(112,112,112,1)",
                }
            }],
            xAxes: [{
                ticks: {
                   fontColor: "rgba(112,112,112,1)",
                },
                gridLines: {
                   display: false,
                   color: "#F7D9F8"
                 },
             }],
        }, 
        tooltips: { 
            callbacks: { 
                label: function(tooltipItems, data) {return 'R$ ' +  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(tooltipItems.yLabel).replace('R$', '')}
            }
        },
        
    }

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

const NovoContratoBtn = () => (
    <div className="novoContrato mt-3 w-100">
        <Link to="/contratos">
            <button type="button" className="btnGrafico">
                Novo Investimento
            </button>
        </Link>
    </div>
)

const DocumentosBtn = () => (
    <div className="novoContrato mt-3">
        <Link to="/minhaconta">
            <button type="button" className="btnGrafico">
                Enviar Documentos
            </button>
        </Link>
    </div>
)

const PermissaoBtn = (props) => (
    <div className="novoContrato mt-3">
        <button type="button" className="btnGrafico" onClick={() => props.onClick(props.userid)}>
            Solicitar Permissão
        </button>
    </div>
)
    
// const NovoContratoBtnDisabled = () => (
//     <div className="novoContratoDisabled mt-3 w-100">
//         <Tooltip title="Por favor, verifique seus documentos ou aguarde aprovação.">
//             <button type="button" className="btnGrafico">
//                 Novo Investimento
//             </button>
//         </Tooltip>
//     </div>
// )
    
const ModeloContrato = () => (
    <div className="novoContrato mt-3 ml-3">
        <Link to={modeloContrato} target="_blank">
            <button type="button" className="btnGrafico">
                Modelo de Contrato
            </button>
        </Link>
    </div>
)

const NoContracts = (props) => (
    <div className="d-flex flex-column align-items-center">
        {!props.success && props.message != null &&
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                <p className="mb-0">{props.message}</p>
            </div>}
        <img src={NoContract} />
        {/* Todos os usuários podem criar investimentos, independente da permissão */}
        <>
            <h4 className="tx-pink w-50 mt-3" style={{fontWeight: 'bold'}}>Você não possui investimentos</h4>
            <div className="d-flex">
                <NovoContratoBtn />
                {/* <ModeloContrato /> */}
            </div>
            {props.nivelVerificacao !== '111' || props.nivelVerificacao === undefined && <DocumentosBtn /> }
        </>
    </div>
)


class ContratoWrapper extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            arquivo: null,
            arquivoAlt: !!props.contrato.arquivo,
            arquivoContrato: props.contrato.arquivo ? String(props.contrato.arquivo).replace(/[\s\S]*\/([^/]+)$/, '$1') : '',
            statusUpload: null,
            loadingChart: false,
            chart: null,
            usefulChart: null,
            modalChart: null,
            loadingModal: false,
            modal: false,
            modalAporteOpened: false,
            dt_inicial: '',
            dt_final: '',
            status: props.contrato.status,
            titleModal: '',
            tipoOperacao: '',
            userId: props.user.id,
            btnDisabled: false,
            modalRenovacaoOpened: false,
            error: {},
            message: '',
            isClicked: 0,
            modalOpenDocModal: false
        }
    }


    handleDateChange = (e) => {
        e.persist()
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    uploadSuccess = () => {
        this.setState({
            statusUpload: 'done',
            arquivoAlt: true
        })
    }

    uploadError = () => {
        this.setState({
            statusUpload: 'error'
        })
    }

    uploadFile = async (file) => {
        this.setState({ statusUpload: 'loading' })
        try {
            const { contrato: { id } } = this.props
            const idUser = this.props.user.id
            if (id | 0) {
                const formData = new FormData()
                formData.append('id', id)
                formData.append('file', file)
                formData.append('idUser', idUser)
                const response = await fetch(`${API_URL}contracts/uploadContrato/${id}`, {
                    method: 'PUT',
                    body: formData,
                    headers: {
                        'Authorization': `Bearer ${getInfoLocalStorage().token}`
                    }
                })
                const { code } = await response.json()
                if (code === 51) {
                    this.uploadSuccess()
                } else {
                    this.uploadError()
                }
            } else {
                this.uploadError()
            }
        } catch(e) {
            this.uploadError()
        }
    }

    beforeUpload = (type) => file => {
        const specialChars = /^[a-zA-Z0-9_-\d ]+$/
        const fileWithoutExtension = file.name.split('.').slice(0, -1).join()
        const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
        const fileSize = file.size
        if (specialChars.test(fileWithoutExtension) === false) {
            this.setState({ error: { type: 'specialChars', message: 'O nome do arquivo não pode conter caracteres especiais e acentos.' }, isClicked: type })
        } else if (acceptedFormats.includes(file.name.split('.')[1]) === false) {
            this.setState({ error: { type: 'typeOfFile', message: 'Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.' }, isClicked: type })
        } else {
            if (fileSize > 5242880) { // 5MB in bytes
                this.setState({ error: { type: 'fileSize', message: 'Por favor, envie arquivos de até 5MB.' }, isClicked: type})
            } else {
                this.setState({
                    arquivoContrato: file.name, 
                    arquivo: file,
                    error: {}
                }, () => {
                    this.uploadFile(file)
                })
            }
        }
        return false
    }

    onRemove = () => {
        if (this.state.statusUpload !== 'done' || !this.state.arquivo) {
            this.setState({
                arquivoContrato: null
            })
        }
    }

    closeModal = () => {
        this.setState({ modal: false })
    }
    closeModalAporte = () => {
        this.setState({ modalAporteOpened: false })
        const { actionClearMessage } = this.props
        actionClearMessage()
    }
    closeModalRenovacao = () => {
        this.setState({ modalRenovacaoOpened: false }, () => { this.props.onLoad(this.props.userid) })
        const { actionClearMessage } = this.props

        actionClearMessage()
    }

    closeModalDoc = () => {
        this.setState({ modalOpenDocModal: false })
        const { actionClearMessage } = this.props
        actionClearMessage()
    }

    openModalDocumento = (e) => {
        this.setState({
            modalOpenDocModal: true
        })
    }

    openModalAporte = (e) => {
        if(e.target.name === 'aporte'){
            this.setState({
                titleModal: 'Realizar aporte',
                tipoOperacao: 'Aporte'
            })
        } else {
            this.setState({
                titleModal: 'Solicitar resgate',
                tipoOperacao: 'Resgate'
            })
        }
        this.setState({
            modalAporteOpened: true
        })
    }

    //nova função
    openModalRenovacaoAporteResgate = (e) => {
        if (e.target.name === "renovacao-total") {
            this.setState({
                titleModal: 'Realizar renovação total',
                tipoOperacao: 'RenovacaoTotal'
            })
        } else if (e.target.name === "renovacao-com-aporte") {
            this.setState({
                titleModal: 'Solicitar renovação com aporte',
                tipoOperacao: 'RenovacaoAporte'
            })
        } else if (e.target.name === "renovacao-com-resgate") {
            this.setState({
                titleModal: 'Solicitar renovação com resgate',
                tipoOperacao: 'RenovacaoResgate'
            })
        } else if (e.target.name === 'resgate-total') {
            this.setState({
                titleModal: 'Solicitar resgate total',
                tipoOperacao: 'ResgateTotal'
            })
        } 
            this.setState({
                modalRenovacaoOpened: true
            })
    };

    componentDidMount() {
        const { contrato } = this.props
        if(Object.keys(contrato).length) {
            this.gerarGrafico()
        }
    }

    gerarGrafico = async () => {
        const { contrato: { id } } = this.props
        const filter = 'geral'
        this.setState({ chart: null, loadingChart: true, usefulChart: null })
        try {
            const response = await request('contracts/grafico', 'POST', { id, filter })
            if (response.code === 11) {
                let aux = response.usefulChart
                let labels = []
                let filter = []
                if(response.chart.datasets[0].data.length > 30) {
                    for(let i = response.chart.datasets[0].data.length - 1; i >= response.chart.datasets[0].data.length - 31; i --){
                        filter.push(response.chart.datasets[0].data[i])
                        labels.push(response.chart.labels[i])
                    }
                } else {
                    for(let i = response.chart.datasets[0].data.length - 1; i >= 0; i --){
                        filter.push(response.chart.datasets[0].data[i])
                        labels.push(response.chart.labels[i])
                    }
                }
                
                aux.datasets[0].data = filter.reverse()
                aux.labels = labels.reverse()
                this.setState({
                    chart: response.chart,
                    message: response.message,
                    usefulChart: aux,
                    modalChart: response.modalChart,
                    btnDisabled: false
                }, () => {
                    this.setState({
                        loadingChart: false
                    })
                })
            } else {
                this.setState({
                    loadingChart: false,
                    btnDisabled: true
                })
            }
        } catch(e) {
            this.setState({ loadingChart: false })
        }
    }

    abrirModal = async () => {
        this.setState({ modal: true })
    }

    filterGrafico = (e) => {
        let aux = this.state.modalChart
        let copy = this.state.chart
        this.setState({
            loadingModal: true,
            modalChart: null
        })
        setTimeout(() => {
            let labels = []
            let filter = []
            if(e == 99){
                for(let i = 0; i < copy.datasets[0].data.length; i++){
                    if(moment(copy.labels[i], "DD/MM/YYYY").toDate() <= moment(this.state.dt_final, "YYYY-MM-DD").toDate() && moment(copy.labels[i], "DD/MM/YYYY").toDate() >= moment(this.state.dt_inicial, "YYYY-MM-DD").toDate()){
                        filter.push(copy.datasets[0].data[i])
                        labels.push(copy.labels[i])
                    }
                }
                aux.datasets[0].data = filter
                aux.labels = labels
            } else if(e == 'full') {
                aux = this.state.chart
            } 
            else {
                if(copy.datasets[0].data.length > e) {
                    for(let i = copy.datasets[0].data.length - 1; i >= copy.datasets[0].data.length - e; i --){
                        filter.push(copy.datasets[0].data[i])
                        labels.push(copy.labels[i])
                    }
                } else {
                    for(let i = copy.datasets[0].data.length - 1; i >= 0; i --){
                        filter.push(copy.datasets[0].data[i])
                        labels.push(copy.labels[i])
                    }
                }
                aux.datasets[0].data = filter.reverse()
                aux.labels = labels.reverse()
            }
            
            this.setState({
                modalChart: aux,
                loadingModal: false,
            })
        }, 1000)
    }

    renderInvestmentCards = () => {
        const { contrato } = this.props;
        
        if (!contrato || !Object.keys(contrato).length) return null;
        
        // Extrair valores do contrato da API
        const valorInicial = parseFloat(contrato.valorInicial) || 0;
        const valorAtual = parseFloat((contrato.ValorContratos[0] || {}).valorDia) || valorInicial;
        const ganhosTotais = valorAtual - valorInicial;
        
        // Obter a última operação do cliente para taxas e rendimentos
        const operacoes = contrato.OperacaoClientes || [];
        const ultimaOperacao = operacoes.length > 0 
            ? operacoes.sort((a, b) => new Date(b.dataOperacao) - new Date(a.dataOperacao))[0] 
            : null;
        
        // Calcular valores de rendimento baseados nos dados da API
        const taxaRendimentoDiario = ultimaOperacao 
            ? parseFloat(ultimaOperacao.rentabilidadeDiariaNormal) * 100 
            : (contrato.ValorContratos[0] ? parseFloat(contrato.ValorContratos[0].taxaRendimentoDiario) : 0);
            
        const rentabilidadeAcumulada = ultimaOperacao 
            ? parseFloat(ultimaOperacao.rentabilidadeAcumulada) * 100
            : 0;
            
        const rentabilidadeMes = ultimaOperacao 
            ? parseFloat(ultimaOperacao.rentabilidadeMes) * 100
            : 0;
        
        // Calcular valores para os cards
        const ganhosDiarios = (valorAtual * taxaRendimentoDiario) / 100;
        const ganhosMensais = ganhosDiarios * 30; // Aproximação de ganhos mensais
        const disponivelSaque = ganhosTotais / 2; // Valor disponível para saque (exemplo)
        
        // Calcular percentuais comparativos
        const percentualGanhoTotal = (ganhosTotais / valorInicial) * 100;
        const tendenciaSaque = disponivelSaque * 0.20; // Exemplo de valor para tendência de aumento do saque
        
        // Calcular desempenho do portfólio
        const desempenhoPortfolio = rentabilidadeAcumulada;
        const variacaoDesempenho = ultimaOperacao ? parseFloat(ultimaOperacao.variacao) * 100 : 0;
        
        // Formatar números para exibição
        const formatarNumero = (valor) => {
            return new Intl.NumberFormat('pt-BR', { 
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(valor);
        };
        
        // Formatar percentuais
        const formatarPercentual = (valor) => {
            const sinal = valor >= 0 ? '+' : '';
            return `${sinal}${valor.toFixed(2)}%`;
        };
        
        return (
            <Row className="investment-summary-cards">
                <Col lg={4} md={6} className="mb-4">
                    <div className="summary-card">
                        <div className="card-header">
                            <span>Valor Total Investido</span>
                            <FontAwesomeIcon icon={faDollarSign} />
                        </div>
                        <div className="card-value">
                            R$ {formatarNumero(valorInicial)}
                        </div>
                        <div className="card-subtitle">
                            Capital total investido neste contrato
                        </div>
                        <div className="card-percentage positive">
                            <FontAwesomeIcon icon={faArrowUp} /> {formatarPercentual(taxaRendimentoDiario)}
                        </div>
                    </div>
                </Col>
                
                <Col lg={4} md={6} className="mb-4">
                    <div className="summary-card">
                        <div className="card-header">
                            <span>Ganhos Acumulados</span>
                            <FontAwesomeIcon icon={faChartLine} />
                        </div>
                        <div className="card-value">
                            R$ {formatarNumero(ganhosTotais)}
                        </div>
                        <div className="card-subtitle">
                            Ganhos totais desde o início do contrato
                        </div>
                        <div className="card-percentage positive">
                            <FontAwesomeIcon icon={faArrowUp} /> {formatarPercentual(percentualGanhoTotal)}
                        </div>
                    </div>
                </Col>
                
                <Col lg={4} md={6} className="mb-4">
                    <div className="summary-card">
                        <div className="card-header">
                            <span>Disponível para Saque</span>
                            <FontAwesomeIcon icon={faWallet} />
                        </div>
                        <div className="card-value">
                            R$ {formatarNumero(disponivelSaque)}
                        </div>
                        <div className="card-subtitle">
                            Valor disponível para saque imediato
                        </div>
                        <div className="card-percentage positive">
                            <FontAwesomeIcon icon={faArrowUp} /> +R$ {formatarNumero(tendenciaSaque)}
                        </div>
                    </div>
                </Col>
                
                <Col lg={4} md={6} className="mb-4">
                    <div className="summary-card">
                        <div className="card-header">
                            <span>Ganhos Mensais</span>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                        </div>
                        <div className="card-value">
                            R$ {formatarNumero(ganhosMensais)}
                        </div>
                        <div className="card-subtitle">
                            Ganhos projetados para o mês atual
                        </div>
                        <div className={`card-percentage ${rentabilidadeMes >= 0 ? 'positive' : 'negative'}`}>
                            <FontAwesomeIcon icon={rentabilidadeMes >= 0 ? faArrowUp : faArrowDown} /> {formatarPercentual(rentabilidadeMes)}
                        </div>
                    </div>
                </Col>
                
                <Col lg={4} md={6} className="mb-4">
                    <div className="summary-card">
                        <div className="card-header">
                            <span>Ganhos Diários</span>
                            <Icon type="clock-circle" />
                        </div>
                        <div className="card-value">
                            R$ {formatarNumero(ganhosDiarios)}
                        </div>
                        <div className="card-subtitle">
                            Média de ganhos diários neste contrato
                        </div>
                        <div className="card-percentage positive">
                            <FontAwesomeIcon icon={faArrowUp} /> {formatarPercentual(taxaRendimentoDiario)}
                        </div>
                    </div>
                </Col>
                
                <Col lg={4} md={6} className="mb-4">
                    <div className="summary-card">
                        <div className="card-header">
                            <span>Desempenho do Portfólio</span>
                            <Icon type="stock" />
                        </div>
                        <div className="card-value">
                            {desempenhoPortfolio.toFixed(2)}%
                        </div>
                        <div className="card-subtitle">
                            Desempenho acumulado do investimento
                        </div>
                        <div className={`card-percentage ${variacaoDesempenho >= 0 ? 'positive' : 'negative'}`}>
                            <FontAwesomeIcon icon={variacaoDesempenho >= 0 ? faArrowUp : faArrowDown} /> {formatarPercentual(variacaoDesempenho)}
                        </div>
                    </div>
                </Col>
            </Row>
        );
    };

    render() {
        const { contrato, actionClearMessage } = this.props  

         return (
            Object.keys(contrato).length > 0 ? (
                <>
                    <div className="cardWrapper">
                        <Container>
                            {/* Investment Summary Cards */}
                            {this.renderInvestmentCards()}
                            
                            <Row>
                                <Col md={12}>
                                    {this.state.status === 12 && (
                                        <div class="alert alert-danger alert-dismissible fade show notificacao-vencidos" role="alert">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <p className="mb-0">O seu contrato venceu. Entre em contato conosco por um de nossos canais para que possamos dar sequencia em sua renovação ou resgate.
                                            </p>
                                        </div>
                                    )}
                                    <div>
                                        {this.state.status === 8 && (
                                            <div class="alert alert-danger alert-dismissible fade show notificacao-vencidos" role="alert">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <p className="mb-0">Seu resgate total de contrato já está disponível. 
                                                    <button className='p-1 ml-2 tx-pink font-weight-bold' style={{ border: 'none', backgroundColor: '#130E24', color: '#ffff', fontSize: '16px' }} name="resgate-total" onClick={this.openModalRenovacaoAporteResgate}>
                                                        Confirmar resgate total
                                                    </button>
                                                </p>
                                            </div>
                                        )}
                                        {this.state.status === 9 && (
                                            <div class="alert alert-danger alert-dismissible fade show notificacao-vencidos" role="alert">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <p className="mb-0">Sua renovação total de contrato já está disponível.
                                                    <button className='p-1 ml-2 tx-pink font-weight-bold' style={{ border: 'none', backgroundColor: '#130E24', color: '#ffff', fontSize: '16px' }} name="renovacao-total" onClick={this.openModalRenovacaoAporteResgate}>
                                                        Renovar contrato
                                                    </button>
                                                </p>
                                            </div>
                                        )}
                                        {this.state.status === 10 && (
                                            <div class="alert alert-danger alert-dismissible fade show notificacao-vencidos" role="alert">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <p className="mb-0">Sua renovação de contrato com resgate já está disponível.
                                                    <button className='p-1 ml-2 tx-pink font-weight-bold' style={{ border: 'none', backgroundColor: '#130E24', color: '#ffff', fontSize: '16px' }} name="renovacao-com-resgate" onClick={this.openModalRenovacaoAporteResgate}>
                                                        Renovar contrato
                                                    </button>
                                                </p>
                                            </div>
                                        )}
                                        {this.state.status === 11 && (
                                            <div class="alert alert-danger alert-dismissible fade show notificacao-vencidos" role="alert">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <p className="mb-0">Sua renovação de contrato com aporte já está disponível.
                                                    <button className='p-1 ml-2 tx-pink font-weight-bold' style={{ border: 'none', backgroundColor: '#130E24', color: '#ffff', fontSize: '16px' }} name="renovacao-com-aporte" onClick={this.openModalRenovacaoAporteResgate}>
                                                        Renovar contrato
                                                    </button>
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <h2 className="tx-gray font-weight-bold">{planos[contrato.tipoContrato] ? planos[contrato.tipoContrato].nome : 'Plano não encontrado'}</h2>
                                    </div>
                                    <Row className="mt-3">
                                        <Col md={4} className='divRendimentos pr-5 d-flex flex-column justify-content-between'>
                                            <div>
                                            <div className="d-flex flex-column">
                                                <label className="tx-pink mt-3">Aporte inicial</label>
                                                <label className="tx-gray labelData font-weight-bold">R${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(contrato.valorInicial).replace('R$', '')  }</label> 
                                            </div>
                                            <div className="d-flex flex-column">
                                                <label className="tx-pink mt-2">Valor atual</label>
                                                <label className="labelValueData tx-gray">R${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((contrato.ValorContratos[0] || {}).valorDia || contrato.valorInicial).replace('R$', '')   }</label>
                                            </div>
                                            </div>
                                            <div className="pb-5">
                                            {/* <div className='d-flex flex-column'>
                                                <label className="tx-pink">Comunicados</label>
                                                <a href="/Carta01.pdf" target="_blank" className="tx-blue">Carta 01</a>
                                                <a href="/Carta02.pdf" target="_blank" className="tx-blue">Carta 02</a>
                                                <a href="/Carta03.pdf" target="_blank" className="tx-blue">Carta 03</a>
                                            </div> */}
                                            {/* {
                                                this.state.status === 1 || this.state.status === 6 || this.state.status === 3 ? (
                                                    !this.state.arquivoAlt ? (
                                                        <Tooltip title="Envie seu contrato assinado.">
                                                            <Button className={`btnGrafico text-white ${!this.state.arquivoAlt ? 'btnAcaoDisabled' : ''}`} name="aporte">Realizar aporte</Button>
                                                        </Tooltip>
                                                    ) : (
                                                        <Button className={`btnGrafico`} name="aporte" onClick={this.openModalAporte}>Realizar aporte</Button>
                                                    )
                                                ) : (
                                                    this.state.status === 8 || this.state.status === 9 || this.state.status === 10 | this.state.status === 11 || this.state.status === 12 ? 
                                                    (
                                                        <Tooltip title="Contrato finalizado.">
                                                            <Button className={`btnGrafico btnAcaoDisabled`} name="aporte">Realizar aporte</Button>
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip title="Contrato ainda não aprovado.">
                                                            <Button className={`btnGrafico btnAcaoDisabled`} name="aporte">Realizar aporte</Button>
                                                        </Tooltip>
                                                    )
                                                )
                                            } */}
                                            {
                                                this.state.status === 1 || this.state.status === 6 || this.state.status === 3 ? (
                                                    !this.state.arquivoAlt ? (
                                                        <Tooltip title="Por favor, envie seu contrato assinado.">
                                                            <Button className={`btnGrafico mt-3 btnAcaoDisabled`} name="saque">
                                                                Solicitar resgate
                                                            </Button>
                                                        </Tooltip>
                                                    ) : (
                                                        <Button className="btnGrafico mt-3" name="saque" onClick={this.openModalAporte}>
                                                            Solicitar resgate 
                                                        </Button>
                                                    )
                                                ) : (
                                                    this.state.status === 8 || this.state.status === 9 || this.state.status === 10 | this.state.status === 11 || this.state.status === 12 ? 
                                                    (
                                                        <Tooltip title="Contrato finalizado.">
                                                            <Button  className={`btnGrafico mt-3 btnAcaoDisabled`} name="saque">
                                                                Solicitar resgate
                                                            </Button>
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip title="Contrato ainda não aprovado.">
                                                            <Button  className={`btnGrafico mt-3 btnAcaoDisabled`} name="saque">
                                                                Solicitar resgate
                                                            </Button>
                                                        </Tooltip>
                                                    )
                                                )
                                            }
                                            </div>                                           
                                        </Col>
                                        <Col md={8}>
                                            <Row className='d-flex justify-content-between'>
                                                <h5 className="tx-pink font-weight-bold text-left mb-4">Gráfico de evolução</h5>
                                                <h5 onClick={this.abrirModal} className="tx-gray labelData cursor-pointer" role="button" ><u>Ver mais</u></h5>
                                                
                                            </Row>
                                            <Row>
                                            {this.state.loadingChart ? (
                                                <div style={{ textAlign: 'center' }}>
                                                    <Icon type="loading" />
                                                </div>
                                            ) : this.state.usefulChart ? (
                                                this.state.usefulChart.labels.length > 0 ? (
                                                <Line legend={{ display: false }} data={this.state.usefulChart} options={options}/>
                                            ) : <Empty description="Não há dados disponíveis" /> ) : <Empty description="Nenhum dado encontrado" />}
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'> 
                                        <Col md={4} className='pr-5'>
                                            
                                            <div>
                                                <label className="tx-pink labelData">Produto de Investimento</label><br />
                                                {contrato.tipoContrato === 6 ? 
                                                <label className="tx-gray labelData">{planos[contrato.tipoContrato].nome}</label> : <label className="tx-gray labelData">{planos[contrato.tipoContrato].nome}</label>
                                                }
                                            </div>
                                                
                                            <div>
                                                
                                                <div className={`documentoWrapper mt-3 ${this.state.status === 2 || this.state.arquivoAlt ? 'pb-2' : 'pb-5'}`}>
                                                    {this.state.status === 2 || this.state.status === 7 ? (
                                                            <div className="infoPerfil d-flex mt-3">
                                                                <Icon type="warning" theme="filled" className="mr-2" />
                                                                <label className="mb-0">Contrato em processo de validação.</label>
                                                            </div>
                                                    ) : (
                                                        !this.state.arquivoAlt ? (
                                                            <div className="infoPerfil d-flex mt-3" style={{ cursor: 'pointer' }}>
                                                                <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                                                                <button type="text" style={{ border: 'none', outline: 'none', backgroundColor: 'rgba(0, 0, 0, 0)' }}><label className="mb-0" style={{ cursor: 'pointer', textAlign: 'initial'}} onClick={this.openModalDocumento}>Por favor, clique aqui para enviar seu <b>contrato assinado.</b></label></button>
                                                            </div>
                                                        ) : (
                                                            <div className="infoPerfil d-flex mt-3">
                                                                <Icon type="check-circle" theme="filled" className="mr-2" />
                                                                <label className="mb-0">Contrato aprovado!</label>
                                                            </div>
                                                        )
                                                    )
                                                    }
                                                </div>
                                            </div>
                                            
                                        </Col>
                                        <Col md={8} >
                                            <div className='d-flex userInfoWrapper pt-0 pb-4'>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">Período</label><br />
                                                    {contrato.tipoContrato === 6 ? <label className="tx-gray labelData">Indeterminado</label> : <label className="tx-gray labelData">{contrato.duracao} meses</label>}
                                                </div>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">Rentabilidade</label><br />
                                                    {contrato.tipoContrato === 6 ? <label className="tx-gray labelData">Variável</label> : <label className="tx-gray labelData">{planos[contrato.tipoContrato].meses[contrato.duracao]} % / {contrato.tipoContrato >= 7 ? 'ano' : 'mês'} + Taxa de Performance</label>}                     
                                                </div>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">Data de Início</label><br />
                                                    <label className="tx-gray labelData">{
                                                        contrato.dataInicio ?
                                                            moment(contrato.dataInicio).format('DD/MM/YYYY')
                                                            : 
                                                            <span style={{ color: '#f00' }}>Contrato ainda<br />não aprovado</span>
                                                    }</label> 

                                                </div>
                                                <div>
                                                    <label className="tx-pink labelData">Data de Vencimento</label><br />
                                                    {contrato.tipoContrato === 6 ? 'Indeterminado' : contrato.dataFim ? moment(contrato.dataFim).format('DD/MM/YYYY'):<span style={{ color: '#f00' }}>Contrato ainda<br />não aprovado</span>}
                                                    {/* {contrato.dataFim ?
                                                            contrato.tipoContrato === 6 ? 'Indeterminado' : moment(contrato.dataFim).format('DD/MM/YYYY')
                                                            : <span style={{ color: '#f00' }}>Contrato ainda<br />não aprovado</span>
                                                        } */}
                                                </div>
                                            </div>
                                            <div className='pt-3'>
                                                <h5 className="tx-pink font-weight-bold text-left">Dados da conta bancária</h5>
                                            </div>
                                            <div className='d-flex pt-3'>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">Nome</label><br />
                                                    <label className="tx-gray labelData">{contrato.Cliente.nome}</label>                               
                                                </div>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">CPF</label><br />
                                                    <label className="tx-gray labelData">{maskCpf(contrato.Cliente.cpf)}</label>                               
                                                </div>                                               
                                            </div>
                                            <div className='d-flex pt-3'>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">Banco</label><br />
                                                    <label className="tx-gray labelData">{contrato.codigoBanco} - {contrato.nomeBanco}</label>                               


                                                </div>
                                                <div className='mr-4'>
                                                    <label className="tx-pink labelData">Agência</label><br />
                                                <label className="tx-gray labelData">{contrato.numeroAgencia}</label>                               

                                                </div>
                                                <div>
                                                    <label className="tx-pink labelData">Conta</label><br />
                                                    <label className="tx-gray labelData">{contrato.numeroConta}</label>                               
                                                </div>
                                            </div>
                                        </Col>  
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Modal
                        className="modalGrafico"
                        title="Gráfico de acompanhamento"
                        visible={this.state.modal}
                        onCancel={this.closeModal}
                        footer={<Button onClick={this.closeModal}>Fechar</Button>}
                    >
                        <Container>
                            <Row>
                                <Col md={12}>
                                    <label>Por período</label><br />
                                </Col>
                                <Col md={12}>
                                    <Button disabled={this.state.btnDisabled} className="btnPeriodo" onClick={() => this.filterGrafico(15)}>Últimos 15 dias</Button>
                                    <Button disabled={this.state.btnDisabled} className="btnPeriodo" id="btn-30" onClick={() => this.filterGrafico(30)}>Últimos 30 dias</Button>
                                    <Button disabled={this.state.btnDisabled} className="btnPeriodo" id="btn-completo" onClick={() => this.filterGrafico('full')}>Completo</Button><br /><br />
                                </Col>
                                <Col md={12}>
                                    <Input style={{ width: 80 }} type="date" name="dt_inicial" onChange={this.handleDateChange} className="periodo-input"></Input>
                                    {/* <small>até</small> */}
                                    <Input type="date" name="dt_final" onChange={this.handleDateChange} className="periodo-input"></Input><br />
                                    <Button disabled={this.state.btnDisabled} className='btnBuscar' onClick={() => this.filterGrafico(99)}>Buscar</Button>
                                </Col>
                                <Col md={12}>
                                    {this.state.loadingModal ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <Icon type="loading" />
                                        </div>
                                    ) : this.state.modalChart ? (
                                        this.state.modalChart.labels.length > 0 ? (
                                        <Line legend={{ display: false }} data={this.state.modalChart} options={options}/>
                                    ) : this.state.message === 'ok' ? ( <Empty description="Datas inválidas" /> ) : <Empty description="Não há dados disponíveis" /> ) : <Empty description="Nenhum dado encontrado" />}
                                </Col>
                            </Row>
                        </Container>
                    </Modal>
                    {this.state.modalAporteOpened ? (
                        <Modal
                    className="modalAporte"
                    title={this.state.titleModal}
                    visible={this.state.modalAporteOpened}
                    onCancel={this.closeModalAporte}
                    footer={[
                        <Button key="cancel" onClick={this.closeModalAporte}>Fechar</Button>
                    ]}
                >
                    <ModalAporte tipo={this.state.tipoOperacao} contrato={contrato} userid={this.state.userId} />
                </Modal>
                    ) : ''}
                    {this.state.modalRenovacaoOpened ? (
                        <Modal 
                        classname="modalAporte"
                        title={this.state.titleModal}
                        visible={this.state.modalRenovacaoOpened}
                        onCancel={this.closeModalRenovacao}
                        width={800}
                        footer={null}
                        >
                            <ModalRenovacao uploadError={this.uploadError} uploadSuccess={this.uploadSuccess} tipoOperacao={this.state.tipoOperacao} contrato={contrato} userid={this.state.userId} closeModal={this.closeModalRenovacao} />
                        </Modal>
                    ) : ''}
                     {this.state.modalOpenDocModal ? (
                         <Modal
                             classname="modalAporte"
                             title={'Envie seu documento assinado aqui'}
                             visible={this.state.modalOpenDocModal}
                             onCancel={this.closeModalDoc}
                             maskClosable = {false}
                             width={400}
                             footer={[
                                <Button key="cancel" onClick={this.closeModalDoc}>Fechar</Button>
                            ]}
                         >
                             {this.state.statusUpload === 'done' ? (
                                 <div className="finishedSignup">
                                     <div>
                                         <h2 style={{ fontSize: '20px' }} >Contrato enviado!</h2>
                                         <p>
                                             Sucesso! Seu contrato foi enviado com sucesso! <br />
                                         </p>
                                     </div>
                                 </div>
                             ) : (
                                     <div className='p-2'>
                                         {this.state.status === 1 || this.state.status === 6 || this.state.status === 3 ? (
                                             <div className={`mt-3 ${this.state.arquivoAlt ? 'novisible' : ''}`}>
                                                 {!this.setState.arquivoAlt ? (
                                                     <Dragger
                                                         beforeUpload={this.beforeUpload(1)}
                                                         onRemove={this.onRemove}
                                                         multiple={true}
                                                     >
                                                         <label className="tx-pink mb-0"><img alt="Ícone upload" src={attach} className="img-fluid mb-2" /><br />Clique ou arraste e solte<br />o arquivo aqui</label>
                                                     </Dragger>
                                                 ) : ''}
                                                 <Icon style={{ fontSize: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }} type={this.state.statusUpload === 'loading' ? 'loading' : ''} />
                                                 {this.state.isClicked === 1 ?
                                                     <>
                                                         <br />
                                                         <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'specialChars' ? this.state.error.message : ''}</small>
                                                         <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'fileSize' ? this.state.error.message : ''}</small>
                                                         <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'typeOfFile' ? this.state.error.message : ''}</small><br />
                                                     </> : ''
                                                 }
                                            <br /></div>
                                         ) : (
                                             ''
                                         )}
                                     </div>
                                 )}
                         </Modal>
                     ) : ''}
                </>
            ) : <NoContracts userid={this.props.userid} onPermissao={this.props.onPermissao} isLoading={this.props.isLoading} success={this.props.success} message={this.props.message} permissao={this.props.permissao} nivelVerificacao={this.props.user && this.props.user.nivelVerificacao ? this.props.user.nivelVerificacao : ''} />
        )
    }
}


const mapDispatchToProps = dispatch => ({
    actionClearMessage: () => {
        // e.preventDefault()
        dispatch(actionClearMessage())
    }
})
// export default ContratoWrapper

export default connect(null, mapDispatchToProps)(ContratoWrapper)